module.exports = __webpack_public_path__ + "img/normal_temp.52065968.svg";